import { RouterProvider } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';
import router from './router/router';
import MenuMobileProvider from 'contexts/UI/menuMobile/MenuMobileProvider';
import UserProvider from 'contexts/user/UserProvider';
import LanguageProvider from 'contexts/UI/language/LanguageProvider';
import CatalogProvider from 'contexts/catalog/CatalogProvider';
import MainContactsProvider from 'contexts/mainContacts/MainContactsProvider';
import MyBrandsProvider from 'contexts/myBrands/MyBrandsProvider';
import MultimediaProvider from 'contexts/multimedia/MultimediaProvider';
import DrawersMultimediaProvider from 'contexts/UI/drawersMultimedia/DrawersMultimediaProvider';
import BrandProvider from 'contexts/brand/BrandProvider';
import PointsOfSaleProvider from 'contexts/pointsOfSale/PointsOfSaleProvider';
import BrandUsersProvider from 'contexts/brandUsers/BrandUsersProvider';
import BrandsProvider from 'contexts/brands/BrandsProvider';
import GoogleAddressProvider from 'contexts/UI/googleAddress/GoogleAddressProvider';
import { memo, useCallback } from 'react';
import NotificationsProvider from 'contexts/notifications/NotificationsProvider';
import SuperAdminProvider from 'contexts/superAdmin/SuperAdminProvider';
import CatalogDownloadProvider from 'contexts/catalogDownload/CatalogDownloadProvider';
import TenantFeedProvider from 'contexts/tenantFeed/tenantFeedProvider';
import MetaProvider from 'contexts/meta/MetaProvider';
import ReferralProgramProvider from 'contexts/UI/referralProgram/ReferralProgramProvider';
import GeneralProvider from 'contexts/general/GeneralProvider';
import CompanyProvider from 'contexts/company/CompanyProvider';
import SalesMatchingProvider from 'contexts/salesMatching/SalesMatchingProvider';
import DataIntegrationProvider from 'contexts/dataIntegration/DataIntegrationProvider';

function App() {
  const getClientId = useCallback(() => {
    if (process.env.REACT_APP_NODE_ENV === 'local' || !process.env.REACT_APP_NODE_ENV) {
      return process.env.REACT_APP_AUTH0_CLIENT_ID_LOCAL;
    } else if (process.env.REACT_APP_NODE_ENV === 'prod') {
      return process.env.REACT_APP_AUTH0_CLIENT_ID_PRODUCTION;
    } else if (process.env.REACT_APP_NODE_ENV === 'dev') {
      return process.env.REACT_APP_AUTH0_CLIENT_ID_DEV;
    } else if (process.env.REACT_APP_NODE_ENV === 'staging') {
      return process.env.REACT_APP_AUTH0_CLIENT_ID_STAGING;
    }
  }, []);

  return (
    <Auth0Provider
      domain={process.env.REACT_APP_AUTH0_DOMAIN as string}
      clientId={getClientId() as string}
      authorizationParams={{
        redirect_uri: window.location.origin + '/',
        audience: process.env.REACT_APP_AUTH0_AUDIENCE as string,
      }}
      // cacheLocation="localstorage"
    >
      <GeneralProvider>
        <LanguageProvider>
          <UserProvider>
            <CompanyProvider>
              <SuperAdminProvider>
                <NotificationsProvider>
                  <MenuMobileProvider>
                    <DrawersMultimediaProvider>
                      <MyBrandsProvider>
                        <PointsOfSaleProvider>
                          <CatalogProvider>
                            <CatalogDownloadProvider>
                              <SalesMatchingProvider>
                                <MultimediaProvider>
                                  <MainContactsProvider>
                                    <BrandProvider>
                                      <TenantFeedProvider>
                                        <BrandUsersProvider>
                                          <BrandsProvider>
                                            <GoogleAddressProvider>
                                              <MetaProvider>
                                                <ReferralProgramProvider>
                                                  <DataIntegrationProvider>
                                                    <RouterProvider
                                                      router={router}
                                                      fallbackElement={<></>}
                                                    />
                                                  </DataIntegrationProvider>
                                                </ReferralProgramProvider>
                                              </MetaProvider>
                                            </GoogleAddressProvider>
                                          </BrandsProvider>
                                        </BrandUsersProvider>
                                      </TenantFeedProvider>
                                    </BrandProvider>
                                  </MainContactsProvider>
                                </MultimediaProvider>
                              </SalesMatchingProvider>
                            </CatalogDownloadProvider>
                          </CatalogProvider>
                        </PointsOfSaleProvider>
                      </MyBrandsProvider>
                    </DrawersMultimediaProvider>
                  </MenuMobileProvider>
                </NotificationsProvider>
              </SuperAdminProvider>
            </CompanyProvider>
          </UserProvider>
        </LanguageProvider>
      </GeneralProvider>
    </Auth0Provider>
  );
}

export default memo(App);
